export const gitVersion = {
  "commit": "f3e07da",
  "commitLong": "f3e07da07d53b3bd814c64a1b70ed4243e0958e8",
  "branch": "Detached: f3e07da07d53b3bd814c64a1b70ed4243e0958e8",
  "tag": "v1.3.19",
  "tagFirst": "v1.3.19"
}